import Vue from 'vue';

Vue.component('fnb-supplier-index', () =>
    import(/* webpackChunkName: 'fnb-supplier-index' */ './supplier-index.vue'),
);



// WEBPACK FOOTER //
// ./resources/assets/js/franchise_component/inventory-fnb/supplier/index.js